module.exports = __webpack_public_path__ + "media/images/icons/settings-f62b2510ecb335086839bbd561fe9c6d.svg";